import { get } from "../../utils/http/HttpClient";

export const healthService = {
    getHealth: async () => {
        const response = await get(`/health`);

        return response;
    }
}